<template>
  <a :href="href" :title="title" class="micad_link">{{text}}</a>
</template>

<script>
export default {
  name: 'Links',
  data() {
    return {
        text: "Lorem ipsum.",
        title: "Quisque tristique quis leo vitae luctus.",
        href: "http://www.loremipsum.com"
        }
    },
};
</script>